import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogsService } from '@mango/core';
import { RelatieService } from 'src/app/core/service/relatie.service';
import { User } from 'src/app/user/user';
import { UserService } from 'src/app/user/user.service';

@Component({
    selector: 'sendmail-alert-popup',
    templateUrl: './sendmail-popup.component.html',
    styleUrls: ['./sendmail-popup.component.css']
})
export class SendMailPopupComponent {

    SendMailFormGroup: FormGroup;
    dialogData: any;

    
    editorOptions= {
        toolbar: [
            ['bold', 'italic', 'underline', 'strike'],

            [{ 'header': 1 }, { 'header': 2 }],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],

            [{ 'size': ['small', false, 'large', 'huge'] }], 

            [{ 'color': [] }, { 'background': [] }],
            [{ 'align': [] }],
            ['link']
           
        ]
    };

    constructor(public dialogRef: MatDialogRef<SendMailPopupComponent>, @Inject(MAT_DIALOG_DATA) public data: any, 
        private fb: FormBuilder, 
        private userService: UserService,
        private relatieService: RelatieService,
        private dialogService: DialogsService
    ) 
    { 
        this.dialogData = data;
    }

    ngOnInit() {

        this.SendMailFormGroup = this.fb.group({
			Subject: this.fb.control(null, null),
            Message: this.fb.control(null, null)
		});

        this.SendMailFormGroup.controls.Subject.setValue("");
        this.SendMailFormGroup.controls.Message.setValue("");       

    }

    async Ok() {

        if (this.dialogData.users.length !== 0) {
            this.userService.startMailingUsers(this.dialogData.users, this.SendMailFormGroup.controls.Subject?.value, this.SendMailFormGroup.controls.Message?.value).subscribe((value) => {
                this.dialogRef.close(true);
                this.dialogService.snackAction("De mailing is succesvol verstuurd!", ()=>{},"ok", 3000);
            });
        }

        if (this.dialogData.relaties.length !== 0) {
            this.relatieService.startMailingRelaties(this.dialogData.relaties, this.SendMailFormGroup.controls.Subject?.value, this.SendMailFormGroup.controls.Message?.value).subscribe((value) => {
                this.dialogRef.close(true);
                this.dialogService.snackAction("De mailing is succesvol verstuurd!", ()=>{},"ok", 3000);
            });
        }

    }

    Cancel(){
        this.dialogRef.close(false);
    }

    onCancel(): void {
        this.dialogRef.close(false);
    }   

    removeUser(index: number){
        
        this.dialogService.confirm("","Weet u zeker dat u deze gebruiker wilt verwijderen uit de lijst ?").then( (value) => {
            if (value){
                this.dialogData.users.splice(index, 1);
            }
        })
    }

    removeRelatie(index: number){
        
        this.dialogService.confirm("","Weet u zeker dat u deze relatie wilt verwijderen uit de lijst ?").then( (value) => {
            if (value){
                this.dialogData.relaties.splice(index, 1);
            }
        })
    }

}
